import {OrderStepTypes} from '../getUserOrderList/types';

export const FAShippingMethodChoice = {
  1: 'پست',
  2: 'تیپاکس',
  3: 'باربری',
} as const;

export enum ShippingMethodChoice {
  POST = 1,
  TIPAX = 2,
  FREIGHT = 3,
}

export enum AdvertisementStatus {
  PUBLISHED = 'published',
  DRAFT = 'draft',
  PENDING = 'pending',
  REJECTED = 'rejected',
}

export enum AdvertisementType {
  STORE = 'store',
  PERSONAL = 'personal',
  REQUIREMENT = 'requirement',
}

export enum SrsType {
  SALE = 'sale',
  RENT = 'rent',
  BUY = 'buy',
  LEASE = 'lease',
}

export enum ProfileType {
  FARMER = 'farmer',
  SUPPLIER = 'supplier',
  BUSINESS = 'business',
  INDIVIDUAL = 'individual',
}

export enum QuantityPackUnit {
  KILOGRAM = 'kilogram',
  GRAM = 'gram',
  LITER = 'liter',
  PIECE = 'piece',
  UNITLESS = 'unitless',
}

export enum StoreStatus {
  ACCEPTED = 'accepted',
  PENDING = 'pending',
  REJECTED = 'rejected',
  SUSPENDED = 'suspended',
}

export const tabsConfig: Array<{value: OrderStepTypes; label: string}> = [
  {value: 'incomplete', label: 'تکمیل نشده'},
  {value: 'pending_approval', label: 'در انتظار تایید'},
  {value: 'supplying', label: 'در حال تامین'},
  {value: 'delivered', label: 'دریافت شده'},
  {value: 'canceled', label: 'لغوشده'},
];

// sent : if order step = 5 and order item step 3

export const enum StoreOrderSteps {
  STARTED = 1, // When the order process is initiated // incomplete
  PENDING_PAYMENT = 2, // Order is awaiting payment // incomplete
  PENDING_PAYMENT_REVIEW = 3, // Waiting for admin to accept payment
  PREPAID = 4, // when the order is already paid via the loan-payment
  PAYMENT_RECEIVED = 5, // Payment has been confirmed
  PROCESSING = 6, // Order is being prepared/packaged
  SHIPPED = 7, // Order has been shipped to the user
  STORE_DELIVERED = 8, // Order has been delivered by store
  USER_DELIVERED = 9, // Order has been delivered by store
  COMPLETED = 10, // Order has been completed and fully closed
  CANCELED = 11, // Order has been canceled}
}

// 1. Define the enum
export enum OrderStepChoice {
  STARTED = 1,
  PROCESSING = 2,
  COMPLETED = 3,
  CANCELED = 4,
}

// 2. Define the labels mapping
export const OrderStepLabels: Record<OrderStepChoice, string> = {
  [OrderStepChoice.STARTED]: 'Started',
  [OrderStepChoice.PROCESSING]: 'Processing',
  [OrderStepChoice.COMPLETED]: 'Completed',
  [OrderStepChoice.CANCELED]: 'Canceled',
};

// 3. Optional: Create a type for the step values
export type OrderStep = OrderStepChoice;

// for user's my orders page
export const FAStoreOrderSteps = {
  1: 'تکمیل نشده',
  2: 'تکمیل نشده',
  3: 'در انتظار تایید',
  4: 'تکمیل نشده',
  5: 'در انتظار تایید',
  6: 'در حال تامین',
  7: 'در حال تامین',
  8: 'در حال تامین',
  9: 'دریافت شده',
  10: 'دریافت شده',
  11: 'لغو شده',
} as const;

export type OrderStepKey = keyof typeof FAStoreOrderSteps;
